export const DEFAULT_PRODUCTION_BACKEND = 'https://ais-dev-ak4qgb56pmoy4ffq5bguvo-135412514041.europe-west1.run.app';

/**
 * Checks if the application is currently running inside the native Android APK wrapper
 * (WebView, Android TV, Capacitor, or custom native Android container).
 */
export function isNativeAndroidApp(): boolean {
  if (typeof window === 'undefined') return false;

  const origin = window.location.origin || '';
  const protocol = window.location.protocol || '';
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

  return (
    origin.includes('appassets.androidplatform.net') ||
    protocol === 'file:' ||
    protocol === 'capacitor:' ||
    protocol === 'ionic:' ||
    protocol === 'content:' ||
    Boolean((window as any).__GAR_COLLECTONIS_NATIVE_ANDROID) ||
    Boolean((window as any).Android) ||
    (ua.includes('Android') && origin.includes('localhost') && window.location.port !== '3000')
  );
}

/**
 * Resolves the appropriate base API URL for backend calls.
 * In browser/web environment on Cloud Run: returns empty string '' (same-origin relative).
 * In native Android WebView, Capacitor, Cordova, Android TV, or file:/// origins:
 * routes to the live Cloud Run backend or user-configured server URL.
 */
export function getApiBaseUrl(): string {
  if (typeof window === 'undefined') return '';

  // 1. User-configured server URL from settings/local storage
  try {
    const customUrl = localStorage.getItem('garcollections_server_url')?.trim();
    if (customUrl) {
      return customUrl.replace(/\/+$/, '');
    }
  } catch {
    // Ignore storage issues
  }

  // 2. Explicit global variable configured in Android wrapper
  if ((window as any).__GAR_COLLECTIONS_SERVER_URL) {
    return String((window as any).__GAR_COLLECTIONS_SERVER_URL).replace(/\/+$/, '');
  }

  // 3. Android WebView, Capacitor, Cordova, or file:// package context check
  const origin = window.location.origin || '';
  const protocol = window.location.protocol || '';
  const hostname = window.location.hostname || '';
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

  const isAndroidOrNativeWrapper = 
    origin.includes('appassets.androidplatform.net') || 
    protocol === 'file:' ||
    protocol === 'capacitor:' ||
    protocol === 'ionic:' ||
    protocol === 'content:' ||
    Boolean((window as any).__GAR_COLLECTONIS_NATIVE_ANDROID) ||
    Boolean((window as any).Android) ||
    // Android device running in local WebView / port other than 3000 without backend
    (ua.includes('Android') && (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '') && window.location.port !== '3000');

  if (isAndroidOrNativeWrapper) {
    return DEFAULT_PRODUCTION_BACKEND;
  }

  return '';
}

/**
 * Helper to prepend the API base URL to any relative /api path
 */
export function buildApiUrl(endpoint: string): string {
  if (!endpoint) return '';
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  const base = getApiBaseUrl();
  const cleanPath = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return base ? `${base}${cleanPath}` : cleanPath;
}

